<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="score"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Score">
            <span class="icon is-small is-left">
                <i class="fas fa-trophy"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            score: {
                get: function () {
                    return this.$store.getters.getNewCarScore
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarScore', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorScore
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/ScoreInput.vue